import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { RootState } from '../app/store';
import { plugAndPlayConfig } from '../config/plugAndPlay';
import { Contractor } from '../pages/MasterData/Contractor/contractorSlice';
import { Discipline } from '../pages/MasterData/Discipline/disciplineSlice';
import { Document } from '../pages/MasterData/Document/documentSlice';
import { User } from '../pages/UserProfile/userProfileSlice';

export default function useMasterDateForDocument(): [
  Contractor[],
  Discipline[],
  Document[],
  User[]
] {
  const { data: contractors } = useSelector(
    (state: RootState) => state.contractors
  );
  const { data: disciplines } = useSelector(
    (state: RootState) => state.disciplines
  );
  const { data: documents } = useSelector(
    (state: RootState) => state.documents
  );

  // Legacy users from Project Register
  const { users: projectRegisterUsers } = useSelector(
    (state: RootState) => state.projectRegisters
  );

  // Plug and Play users from project-specific API
  const { data: projectUsers } = useSelector(
    (state: RootState) => state.projectUsers
  );

  // Environment-based user selection
  const users: User[] = useMemo(() => {
    if (plugAndPlayConfig.isEnabled) {
      return projectUsers || [];
    }
    return projectRegisterUsers || [];
  }, [projectUsers, projectRegisterUsers]);

  return [contractors, disciplines, documents, users];
}
